import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableManagementWrapperStyled = styled.div`
  padding-bottom: 3rem;
  top: 0;
  background-color: ${colors.neutral[100]};
  position: relative;
  z-index: 1;
`;
